const shopChangePass = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'shopChangePass',
            data: param
        })
    }
  }
const shopChangeEdit = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'shopChangeEdit',
            data:param
        })
    }
  }
const shopChangeClear = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'shopChangeClear'
        })
    }
  }

export {shopChangePass, shopChangeClear, shopChangeEdit}